import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, className = "", y = 32 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines = [], lineClassName = "", delay = 0, immediate = false }) {
  const reduce = useReducedMotion();
  const trigger = immediate
    ? { animate: reduce ? { opacity: 1 } : { y: "0%", opacity: 1 } }
    : { whileInView: reduce ? { opacity: 1 } : { y: "0%", opacity: 1 }, viewport: { once: true, margin: "-60px" } };
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={reduce ? { opacity: 0 } : { y: "112%", opacity: 1 }}
            {...trigger}
            transition={{ duration: 0.95, ease: EASE, delay: delay + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}

export function ImageReveal({ src, alt = "", className = "", imgClassName = "" }) {
  const reduce = useReducedMotion();
  return (
    <div className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        initial={reduce ? { opacity: 0 } : { scale: 1.08, opacity: 0.6 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.4, ease: EASE }}
        className={`w-full h-full object-cover ${imgClassName}`}
      />
    </div>
  );
}

export function Eyebrow({ children, light = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-[11px] font-sans font-semibold uppercase tracking-[0.28em] ${
        light ? "text-rose" : "text-burgundy/80"
      } ${className}`}
    >
      <span className={`h-px w-8 ${light ? "bg-gold" : "bg-gold"}`} aria-hidden="true" />
      {children}
    </span>
  );
}
